/**
 * Prioritize screen reader's lecture of aria lives triggered at the same time.
 *
 * Problem: If multiple aria-live regions are updated at the same time, the order in
 * which they are read by the screen reader may depend on the timing of the updates.
 * If one region is updated slightly before another, it may be read first by the screen
 * reader, even if the regions are specified in a different order in the HTML.
 *
 * Important: This directive just slows down the appearance of the aria-lives with
 * order greater than 2.
 *
 * @type {*|directive}
 */

var AriaLiveOrderDirective = function ($timeout) {
    return {
        restrict: "A",
        transclude: "true",
        template: '<div ng-show="showContent" ng-transclude></div>',
        scope: {
            ngIf: "=",
            srOrder: "@"
        },
        link: function ($scope) {
            $scope.showContent = false;
            var time = (!$scope.srOrder ? 0 : $scope.srOrder - 1) * 100;
            $timeout(function () {
                $scope.showContent = !$scope.ngIf ? true : $scope.ngIf;
            }, time);
        }
    };
};

AriaLiveOrderDirective.$inject = ["$timeout"];
export default AriaLiveOrderDirective;
